import {Configuration} from "./generated";
import axios from "axios";

export const MAIN_SERVER_URL="ilots.dev.tdd.rl-conseils.net"

export let serverUrl = window.location.protocol + "//" + window.location.host;
if (window.location.hostname === "localhost" && window.location.port === "3000") {
    console.log("Running on localhost, using dev server",window.location.port);
    serverUrl = "https://"+MAIN_SERVER_URL;
}

export const config = new Configuration({});

export const axiosInstance = axios.create({

});
